export enum PinForDays {
  ONE = '1',
  THREE = '3',
  SEVEN = '7',
  NEVER = '0',
}
